import { Navigate, Route, Routes } from 'react-router-dom';
import Spinner from '../../spinner/Spinner';
import { PropsWithChildren, Suspense } from 'react';
import routes from './routes';
import './defaultLayout.scss'
import NavBar from '../navBar/NavBar';

const DefaultLayout = (props: PropsWithChildren) => {
    return (
        <div className="wrapper">
            <NavBar />
            <Suspense fallback={<Spinner />}>
                <Routes>
                    {routes.map((route) => {
                        const { name, path, Component } = route;
                        return Component ? <Route key={name} path={path} element={<Component {...props} />} /> : null;
                    })}
                    <Route path="/*" element={<Navigate replace to="/" />} />
                </Routes>
            </Suspense>
        </div>
    );
};

export default DefaultLayout;
